import {forOwn,indexOf} from 'lodash'
export default {
  methods: {
		fillUrl(...val) {
			const query = Object.assign({}, ...val)
			this.cleanupQueryObject(query)
			this.$router.replace({
				name: this.currentRouteName,
				query: query
			})
		},
		// url中的string转为number
		objectPropertiesInt(obj, properties) {
			forOwn(obj, (v, k) => {
				if (indexOf(properties, k) > -1) {
					if (v !== '' && v !== undefined) {
						obj[k] = parseInt(v, 10)
					}
				}
			})
			return obj;
		},
		// 清除空字段
		cleanupQueryObject(val) {
			forOwn(val, (v, k) => {
				if (v === '' || k === undefined || k === []) {
					delete val[k]
				}
			})
		},
		// 从路由中获取参数
		getObjectFromRoute() {
			let params = {...this.$route.query}
			const {page,...restParams} = params
			return restParams
		}
	},
	
}

